var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-block text-center staffHover",attrs:{"href":_vm.$router.resolve({
      name: 'staffItem',
      params: { slug: _vm.slug, id: _vm.id }
    }).href}},[_c('v-avatar',{attrs:{"size":"150px","color":"primary"}},[(_vm.imgUrl)?_c('v-img',{attrs:{"src":_vm.imgUrl,"alt":_vm.name}}):_c('span',{staticClass:"white--text text-h5 text-uppercase",domProps:{"textContent":_vm._s(_vm.name.slice(0, 1))}})],1),_c('h5',{staticClass:"text-subtitle-2 black--text text-uppercase text-center mx-2 mt-3",domProps:{"textContent":_vm._s(_vm.name)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }